// extracted by mini-css-extract-plugin
module.exports = {"contentCard":"content-card_contentCard__aY9wt"};